import OtherAddrEdit from './OtherAddrEdit'

export default OtherAddrEdit
